<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Invoicing
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Invoice</b-button>
          <button class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print Bill</button>
          <button class="btn btn-primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</button>
          <button class="btn btn-primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
                  <b-input-group>
                    <b-input-group-prepend><label>Invoicing</label></b-input-group-prepend>
                        <b-form-radio-group class="mt-2" v-model="tblData.status" >
                          <b-form-radio value="1">Proforma</b-form-radio>
                          <b-form-radio value="2">Monthly</b-form-radio>
                          <b-form-radio value="2">on Completed</b-form-radio>
                          <b-form-radio value="3">on Stopped</b-form-radio>
                          <b-form-radio value="">All</b-form-radio>
                        </b-form-radio-group>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Status</span></b-input-group-prepend>
                        <b-form-select v-model="tblData.isinvoiced" :plain="true" :options="invoiced"></b-form-select>
                  </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Platform</label></b-input-group-prepend>
                <b-form-radio-group class="mt-2" v-model="tblData.platform" >
                  <b-form-radio value="cetak">Cetak/Newspaper</b-form-radio>
                  <b-form-radio value="website">Online Website</b-form-radio>
                  <b-form-radio value="mobile">Online Mobile</b-form-radio>
                  <b-form-radio value="">All Media</b-form-radio>
                </b-form-radio-group>
              </b-input-group>
              <b-row>
                <b-col md="6" xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Nomor OPI</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.orderno" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6"  xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Sales Order No.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.mediaorder" ></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>  
        </b-col>
        <b-col md="6" xl=5>
              <b-input-group >
                <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                <b-form-input v-model="tblData.pemasang" @change="tblData.customer_id=''" placeholder="Perushaan Biro Iklan/Perorangan"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser" class="ml-1"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Sales Executive</label></b-input-group-prepend>
                <b-form-input v-model="tblData.sales_search"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Description</span></b-input-group-prepend>
                <b-form-input v-model="tblData.juduliklan"></b-form-input>
              </b-input-group>
              <b-row>
                <b-col lg="8">
                  <b-input-group >
                      <b-input-group-prepend><label >Tanggal OPI</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
                  </div>
                </b-col>
              </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jiklan)="data">
          {{data.item.jiklan}} ({{data.item.jwarna}})
        </template>

        <template v-slot:cell(total)="data">
          {{data.item.total | numFormat}}
        </template>
        <template v-slot:cell(completed)="data">
          <span v-if="data.item.completed == 1">{{ data.item.completeda | moment("DD MMM YYYY") }}</span>
        </template>
        completed
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing
            {{(tblData.page - 1) * tblData.limit + 1}}
            to
            {{tblData.page * tblData.limit}}
            of
            {{tblData.total}}
            entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import opi from "../../apis/koran_iklaninvoicing";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading},
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            closevoidnote: { required },
        },
  }, 
  data() {
    return {
      lkuCustomerShow: false,
      showFilter: false,
      showDelConfirm: false,
      invoiced: [{value:'0', text:'belum diinvoicekan'},{value:'1', text:'sudah diinvoicekan'},,{value:'', text:'semua'}],
      file:null,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      tblData: {
        status:"",
        postgroup:"",
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      pagination:false,
      model:{},
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true,
            thStyle: "width:90px",
            thClass: "text-center",
          },
          {
            key: "CustName",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
          },
          {
            key: "ukuraniklan",
            label: "Ukuran",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "platform",
            label: "Platform",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "posisirubrik",
            label: "Posisi",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "jmlmuat",
            label: "Freq. Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "total",
            label: "Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "realmuat",
            label: "Realisasi Muat",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "completed",
            label: "Complete Date",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "invoiceno",
            label: "Invoice No.",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "SalesEx",
            label: "Sales Ex.",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      ]
      return fields;
    },
  },
  created: async function(){
        const now = new Date();
        const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        this.tblData.tgl2=this.tblData.tgl2 || tgl2;
  },  
  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.pemasang = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.OpiInvoicing) {
            this.tblData[key] = filter.OpiInvoicing[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.OpiInvoicing.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.OpiInvoicing;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await opi.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await opi.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }

    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.juduliklan=  '';
        this.tblData.orderno=  '';
        this.tblData.platform=  '';
        this.tblData.customer_id=  '';
        this.tblData.pemasang=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';

        this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','orderdate', 'orderno', 'customer_id', 'platform', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand'];
      let filtered = false;
      const OpiInvoicing={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              OpiInvoicing[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          OpiInvoicing.page=this.tblData.page;
          OpiInvoicing.limit=this.tblData.limit;
          OpiInvoicing.sortBy=this.tblData.sortBy;
          OpiInvoicing.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.OpiInvoicing=OpiInvoicing;
          this.$store.commit("filter", filter);
      }
    },    
    add(){
          this.saveFilter();
          router.push({name :'iklankoran.orderpasangiklanfrm'});
    },
    edit: function() {
        if (this.model.orderid) {
          this.saveFilter();
          router.push({name :'iklankoran.orderpasangiklanfrm', params: { orderid: this.model.orderid}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.orderid) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await opi.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if( record.status === '111' ){
      //   this.disabledDelete = true;
      //   this.disabledCloseVoid   = false;
      // }else{
      //   this.disabledDelete = false;
      //   this.disabledCloseVoid   = true;
      // }

      // if (this.model.orderid == record.orderid) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    print: async function()
    {
      if (this.model.orderid) {
          try {
                this.showReport=true;
              this.reportUrl = await opi.print({ orderid: this.model.orderid});
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
              // console.log(error);
          }
        } else {
           this.isLoading=false;
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    postingConfirm: async function () {
        if (this.model.orderid) {
            if ((this.model.send2wf || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.send2wf == 1) {
                const data = await task.approvalhistory({key: this.model.orderid});
                this.approvalHistory=data;
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    posting: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.orderid);
            this.showPostingConfirm = false;
            this.isLoading=true;
            const resp = await opi.posting(formData);
            // this.model.posting=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    postingUndo: async function(){
        this.isLoading=true;
        try {
            await opi.postingUndo(this.model);
            // this.model.postingConfirm=0;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.orderid) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.orderid});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
    progress: async function()
    {
        if (this.model.orderid) {
          // if ((this.model.iscomplete==1) && (this.model.issuccess==1)) {
              const filter = this.$store.state.filter;
              filter.OpiInvoicing=this.tblData;
              this.$store.commit("filter", filter);
              router.push({name :'budget.mstrbudgetprogress', params: { orderid: this.model.orderid}});
          // } else {
          //   toastr.warn('Approval in Progress, no transaction/requesition for the budget !');
          // }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await opi.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'opiment.home'});
          router.push({name: "iklankoran.home"});
    }

  }
};
</script>
